import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import clientRoutes from './modules/clients'
import myCompanyRoutes from './modules/myCompany'
import genericRoutes from './modules/genericRoutes'
import mojArhiv from './modules/mojArhiv'

Vue.use(Router)

let routes = [

]
routes = [...genericRoutes, ...clientRoutes, ...myCompanyRoutes, ...mojArhiv, ...routes]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (pathRequiresGuest(to)) {
    if (!userIsLoggedIn()) {
      next()
    } else {
      next({ name: 'Home' })
    }
  } else {
    if (userIsLoggedIn()) {
      store.dispatch('auth/tryAutoLogout')
        .then(() => {
          // if (pathIsForChildCompany(to) && !childCompanyUserIsTaken()) {
          //   next({ name: 'Home' })
          // } else {
          next()
          // }
        })
    } else {
      next({ name: 'Login', query: { redirectTo: to.path } })
    }
  }
})

const pathRequiresGuest = path => {
  return path.matched.some(route => route.meta.requiresGuest)
}

const userIsLoggedIn = () => {
  return store.state.auth.jwt
}

// const pathIsForChildCompany = to => {
//   return to.name.substring(0, 9) === 'MyCompany'
// }

// const childCompanyUserIsTaken = () => {
//   return userIsLoggedIn && store.state.auth.masterJwt
// }

export default router
